module.exports = __webpack_public_path__ + "static/media/KLO.f0d559c2.png";